export type IShowFormLinkSearchPopup = (
  fieldFormLinkId: string,
  formLocalCode: string,
  parentDataBundleUUID: string,
  fieldSuffix: string,
  triggerElement?: IjQueryElmOrHtmlElm
) => void;

export function showFormLinkSearchPopup(
  fieldFormLinkId: string,
  formLocalCode: string,
  parentDataBundleUUID: string,
  fieldSuffix: string,
  triggerElement?: IjQueryElmOrHtmlElm
): void {
  const $modal = $(`#formlink-search-modal-${fieldFormLinkId}`);
  const $loading = $modal.find('.loading');
  const $content = $modal.find('.data-container');
  const url = `${window.actionBaseUrl}form_link_search?pageIndex=1&pageSize=10&fieldFormLinkId=${fieldFormLinkId}&formLocalCode=${formLocalCode}&puuid=${parentDataBundleUUID}&fieldSuffix=${fieldSuffix}`;

  if (triggerElement) {
    window.DexeroCoreApp.lastModalTrigger = triggerElement;
  }

  // Setup modal
  $loading.removeClass('hide').attr('aria-hidden', 'false');
  $content.addClass('hide').attr('aria-hidden', 'true');
  // Show modal
  $modal.modal('show');
  // Get content
  $.get(url).done((responseData) => {
    $content.empty().append(responseData).removeClass('hide').attr('aria-hidden', 'false');
    $loading.addClass('hide').attr('aria-hidden', 'true');
    window.DexeroCoreApp._hookupSearchInFormLinkSearchPopup(
      $content.find(`#searchValue${fieldFormLinkId}`) as JQuery<HTMLInputElement>
    );
  });
}
